// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__mI6Ou","productName":"Table_productName__1oKpM"};